import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import { channelRecordingsQueryKeys } from './query-keys';

export type TDeleteChannelRecordingParams = {
  id: string;
};

export async function deleteChannelRecording({
  id,
}: TDeleteChannelRecordingParams): Promise<undefined> {
  return mediaManagerClient.delete(`/api/v1/channel_recordings/${id}`).then(({ data }) => data);
}

type MutationFn = typeof deleteChannelRecording;

type TUseDeleteSegmentLogoParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteChannelRecording({ config = {} }: TUseDeleteSegmentLogoParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: deleteChannelRecording,
    onError(error) {
      addErrorNotification(t('No se ha podido eliminar la programación de grabación'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('La programación de grabación se ha eliminado correctamente'));
      queryClient.invalidateQueries({ queryKey: channelRecordingsQueryKeys.all });
    },
  });
}
